const u = (id) => `https://images.unsplash.com/${id}?w=1600&q=80&auto=format&fit=crop`;

export const IMAGES = {
  studio: u('photo-1611784728558-6c7d9b409cdf'),
  crew: u('photo-1632187981988-40f3cbaeef5e'),
  film: u('photo-1485846234645-a62644f84728'),
  dubai: u('photo-1512453979798-5ea266f8880c'),
  dubai2: u('photo-1518684079-3c830dcef090'),
  fashion: u('photo-1469334031218-e382a71b716b'),
};

export const CONTACT = {
  email: 'connect@thebuttermedia.com',
  web: 'www.thebuttermedia.com',
  city: 'Dubai, United Arab Emirates',
};

export const SOCIALS = {
  linkedin: 'https://www.linkedin.com/company/the-butter-media',
  instagram: 'https://www.instagram.com/thebuttermedia/',
};

export const REELS = [
  { id: 'reel-1', type: 'mp4', src: '/assets/video/chopsis.mp4', poster: '/assets/work/chopsis.jpg', href: 'https://www.instagram.com/p/DcyadXZA3pr/', label: 'Chopsi’s — Meet the Chef' },
  { id: 'reel-2', type: 'mp4', src: '/assets/video/nalyze.mp4', poster: '/assets/work/nalyze-poster.jpg', href: 'https://www.instagram.com/p/Dc5UWXlsmAV/', label: 'nAlyze — Brand Film' },
  { id: 'reel-4', type: 'mp4', src: '/assets/video/absolute-mark.mp4', poster: '/assets/work/absolute-mark-poster.jpg', href: 'https://www.instagram.com/p/DcTO0gIoCY7/', label: 'Absolute Mark — Showcase' },
  { id: 'reel-3', type: 'mp4', src: '/assets/video/rawthar-cars.mp4', poster: '/assets/work/rawthar-cars-poster.jpg', href: 'https://www.instagram.com/rawtharshah_official/', label: 'Rawthar Shah — Episode Ten' },
];

const DAMAS = (n) => `/assets/work/damas/${n}.jpg`;
const SIXTH = (n) => `/assets/work/6thstreet/${n}.jpg`;

export const FOUNDERS = [
  {
    name: 'Hussein Zohair',
    role: 'Chief Content Architect',
    phone: '+971 55 25 90 371',
    email: 'hussein@thebuttermedia.com',
  },
  {
    name: 'Burhanuddin Zohair',
    role: 'Chief Visual Artist',
    phone: '+971 56 33 38 802',
    email: 'burhan@thebuttermedia.com',
  },
];

export const CLIENTS = [
  'Damas', '6thStreet', 'Bread n Batter Co', 'we.men',
  'CAMB.AI', 'Battmobile', 'Carpet Centre', 'Pop & Palm Events', 'Knot Home',
  'Absolute Mark Interiors', "Chopsi's", 'Legacy Talks with Rosemin',
  'Six Pawz',
];

export const SERVICES = [
  {
    num: '01',
    title: 'Content Strategy',
    tagline: 'The route before the noise.',
    blurb: 'Content strategy, planning, brand positioning and growth roadmaps — we get to know your brand, your audience and your objectives, then map content that aligns with your vision.',
    items: ['Content strategy', 'Content planning', 'Brand positioning', 'Growth roadmaps'],
  },
  {
    num: '02',
    title: 'Copywriting',
    tagline: 'Words built to hold attention.',
    blurb: 'Copywriting, scriptwriting, captions and concepts crafted by wordsmiths — messages that resonate, engage and drive results.',
    items: ['Copywriting', 'Scriptwriting', 'Captions', 'Concepts'],
  },
  {
    num: '03',
    title: 'Video Content',
    tagline: 'Reels, brand films and everything between.',
    blurb: 'Camera junkies on set and video benders in the edit — photography, videography, on-set direction, reel cuts and VFX, shot and finished in-house.',
    items: ['Photography', 'Videography', 'On-set direction', 'Reel cuts', 'VFX'],
  },
  {
    num: '04',
    title: 'Graphic Design',
    tagline: 'Pixels pushed with intent.',
    blurb: 'Graphic design, visual identity, statics, carousels and brand assets — a visual language your audience recognises in a heartbeat.',
    items: ['Graphic design', 'Visual identity', 'Statics', 'Carousels', 'Brand assets'],
  },
  {
    num: '05',
    title: 'Social Media',
    tagline: 'Feeds worth stopping for.',
    blurb: 'Scheduling, community management and always-on content calendars — we keep your channels warm, responsive and unmistakably you.',
    items: ['Scheduling', 'Community management', 'Content calendars'],
  },
];

export const BILINGUAL = {
  title: 'Bilingual Excellence',
  blocks: [
    {
      name: 'Bilingual Content Creation',
      copy: 'Flawless translation and localization in English and Arabic that speaks directly to your target audience — consistent and powerful in both languages.',
    },
    {
      name: 'Cultural Adaptation',
      copy: 'Content tailored to fit cultural nuances, ensuring it resonates with diverse audiences across the region and beyond.',
    },
  ],
};

export const WHY_US = [
  {
    num: '01',
    title: 'Decades of Experience',
    copy: 'Our team’s extensive experience across industries enables us to deliver content that is not only creative but effective. We understand the nuances of different sectors and tailor our approach to your needs.',
  },
  {
    num: '02',
    title: 'Agility & Speed',
    copy: 'In today’s fast-paced world, agility is key. We deliver high-quality content quickly and efficiently, without compromises — tight deadline or ongoing support, we adapt to your timeline.',
  },
  {
    num: '03',
    title: 'Bilingual Excellence',
    copy: 'Fluent in English and Arabic, we provide seamless translation and content creation for a global audience. Your message stays consistent and powerful in both languages.',
  },
  {
    num: '04',
    title: 'Client-Centric Approach',
    copy: 'Your success is our success. We work closely with you to understand your goals and deliver customised content solutions that drive results.',
  },
];

export const PROCESS = [
  { num: '01', title: 'Understanding Your Needs', copy: 'We start by getting to know your brand, your audience and objectives to create content that aligns with your vision.' },
  { num: '02', title: 'Tailored Strategy', copy: 'We develop a content strategy that is customised to your needs.' },
  { num: '03', title: 'Content Creation', copy: 'Expert writers, designers, translators and content creators craft compelling content that speaks directly to your audience.' },
  { num: '04', title: 'Review & Revise', copy: 'We believe in collaboration — you provide feedback and we revise until it satisfies.' },
  { num: '05', title: 'Final Delivery', copy: 'Once approved, we deliver polished content ready to engage, inform and convert.' },
];

export const TOOLS = {
  ai: {
    title: 'AI-Powered Content Strategy',
    points: [
      'Timelines managed effectively — every project delivered on time',
      'Trend, behaviour and keyword analysis that shapes relevant content',
      'Preliminary Arabic translations, transcreated by professional Arabic writers for cultural accuracy and impact',
    ],
  },
  design: ['Illustrator', 'Photoshop', 'Lightroom', 'After Effects', 'Final Cut'],
  cms: ['Wix', 'Shopify', 'WordPress', 'Salesforce'],
};

export const TEAM_ROLES = ['Strategists', 'Writers', 'Designers', 'Content Creators', 'Videographers', 'Video Editors', 'Animators'];

export const WORK_FILTERS = [
  { key: 'all', label: 'All', testid: 'portfolio-filter-all' },
  { key: 'film', label: 'Film', testid: 'portfolio-filter-film' },
  { key: 'brand', label: 'Brand', testid: 'portfolio-filter-brand' },
  { key: 'social', label: 'Social', testid: 'portfolio-filter-social' },
  { key: 'digital', label: 'Digital', testid: 'portfolio-filter-digital' },
];

export const WORK = [
  {
    id: 'work-1',
    client: 'Damas',
    title: 'Alif & Ananya, In Focus',
    category: 'Photography & E-commerce',
    filter: 'film',
    year: '2026',
    image: DAMAS('necklace-model'),
    gallery: [
      DAMAS('necklace-model'), DAMAS('bracelet-editorial'), DAMAS('ring-model'), DAMAS('bracelet-flat'),
      DAMAS('necklace-detail'), DAMAS('ring-hand'), DAMAS('bracelet-wrist'), DAMAS('necklace-flat'), DAMAS('portrait'),
    ],
    link: { label: 'See it live on damasjewellery.com', href: 'https://www.damasjewellery.com/ae-en/alif-mosaic-malachite-necklace-in-18k-rose-gold-alfmos-nl001a00-pk00/' },
    summary: 'Product and on-model photography for one of the region’s most iconic jewellery houses — the Alif Brilliance bracelet, Alif Mosaic malachite necklace and Ananya AKT diamond ring, shot by Butter Media and live on damasjewellery.com.',
    challenge: 'Fine jewellery is unforgiving on camera. Every facet, chain link and malachite inlay had to read true to life, in a warm editorial light that matched the Damas world — for both product pages and campaign use.',
    solution: 'We shot the pieces in-house: clean product stills on warm stone, macro detail crops of clasps and settings, and on-model editorial frames in black and ivory silk — then retouched and delivered every asset e-commerce ready.',
    deliverables: ['Product photography', 'On-model editorial stills', 'Macro detail crops', 'Retouching', 'E-commerce assets'],
    outcome: 'Every image you see here is ours — now live across Damas product pages.',
  },
  {
    id: 'work-7',
    client: 'nAlyze Business Consultants',
    title: 'Meet nAlyze',
    category: 'Brand Film',
    filter: 'film',
    year: '2026',
    image: '/assets/work/nalyze.jpg',
    reel: { type: 'youtube', id: 'txFkSgbxl4E' },
    link: { label: 'Watch on YouTube', href: 'https://www.youtube.com/watch?v=txFkSgbxl4E' },
    summary: 'A brand film introducing nAlyze Business Consultants — business setup and support in the UAE — scripted, shot and edited by Butter Media.',
    challenge: 'Business setup is paperwork-heavy and trust-driven. nAlyze needed a film that made a complex service feel clear, human and approachable in a few minutes.',
    solution: 'We wrote the script, directed the shoot and cut the edit in-house — a warm, straight-talking introduction to the team and what they do for founders landing in the UAE.',
    deliverables: ['Scriptwriting', 'Direction', 'Videography', 'Edit & grade'],
    outcome: 'Live on YouTube as nAlyze’s front-door introduction.',
  },
  {
    id: 'work-2',
    client: '6thStreet',
    title: 'Two Languages, One Voice',
    category: 'Bilingual Copywriting',
    filter: 'social',
    year: '2026',
    image: '/assets/work/6thstreet-cover.jpg',
    galleryFit: 'contain',
    galleryLayout: 'stacked',
    gallery: [
      SIXTH('en-sport-collective'), SIXTH('ar-daily-edits'), SIXTH('en-sneakers'),
      SIXTH('ar-sneakers'), SIXTH('en-watch'), SIXTH('ar-payday'),
    ],
    link: { label: 'Shop the campaigns on 6thstreet.com', href: 'https://en-ae.6thstreet.com/' },
    summary: 'English and Arabic banner copy for the region’s fashion e-commerce giant — Sport Collective, Sneaker Central, The Daily Edits, watches and payday drops, written to convert in both languages.',
    challenge: 'Fashion moves daily and every banner has seconds to earn a click. 6thStreet needed headlines and CTAs that land equally hard in English and Arabic — not translated, transcreated.',
    solution: 'We write the campaign copy in both languages side by side: punchy English headlines, then Arabic lines rebuilt for rhythm, culture and the way Gulf shoppers actually read — delivered at retail speed, drop after drop.',
    deliverables: ['English banner copy', 'Arabic transcreation', 'Campaign headlines & CTAs', 'Always-on delivery'],
    outcome: 'Live across 6thstreet.com and app — in both languages, every week.',
  },
  {
    id: 'work-8',
    client: 'Chopsi’s',
    title: 'Meet the Chef',
    category: 'Reel & Social',
    filter: 'social',
    year: '2026',
    image: '/assets/work/chopsis.jpg',
    reel: { type: 'mp4', src: '/assets/video/chopsis.mp4', poster: '/assets/work/chopsis.jpg' },
    link: { label: 'Watch on Instagram', href: 'https://www.instagram.com/p/DcyadXZA3pr/' },
    summary: 'A talking-head reel for Chopsi’s — the chef, in her own words, shot on location and cut for Instagram by Butter Media.',
    challenge: 'Restaurants live on Instagram, but most feeds are food shots and nothing else. Chopsi’s needed a face and a voice — something that makes people feel they already know the place before they walk in.',
    solution: 'We put the chef in front of the camera inside the restaurant, kept the set-up simple and warm, and cut a vertical reel that lets her personality carry the brand.',
    deliverables: ['Reel concept', 'On-location shoot', 'Vertical edit', 'Instagram delivery'],
    outcome: 'Live on @chopsis.restaurant.',
  },
  {
    id: 'work-9',
    client: 'Absolute Mark Interiors',
    title: 'The Absolute Mark Difference',
    category: 'Video Showcase',
    filter: 'film',
    year: '2026',
    image: '/assets/work/absolute-mark.jpg',
    reel: { type: 'mp4', src: '/assets/video/absolute-mark.mp4', poster: '/assets/work/absolute-mark-poster.jpg' },
    link: { label: 'Watch on Instagram', href: 'https://www.instagram.com/p/DcTO0gIoCY7/' },
    summary: 'A vertical showcase reel for Absolute Mark Interiors — their projects, their difference, cut for the feed by Butter Media.',
    challenge: 'Interiors photograph beautifully but sit still. Absolute Mark needed their work to move — a reel that shows the craft and says why they’re different, in under a minute.',
    solution: 'We built the showcase around one idea — the Absolute Mark difference — pacing the footage to a cinematic soundtrack with clean title cards and a vertical cut made for Instagram.',
    deliverables: ['Showcase concept', 'Vertical edit', 'Title design', 'Sound & pacing'],
    outcome: 'Live on @theabsolutemark.',
  },
  {
    id: 'work-10',
    client: 'Priyanka Real Estate Advisor',
    title: 'Rahman Island, On Camera',
    category: 'Social Media & Reels',
    filter: 'social',
    year: '2026',
    image: '/assets/work/priyanka-poster.jpg',
    reel: { type: 'mp4', src: '/assets/video/priyanka.mp4', poster: '/assets/work/priyanka-poster.jpg' },
    link: { label: 'Follow @priyankabhatia.uae', href: 'https://www.instagram.com/priyankabhatia.uae/' },
    summary: 'We run the Instagram page of Dubai real estate advisor Priyanka Bhatia — reels, captions and a feed that sells property through personality, not listings.',
    challenge: 'Dubai real estate is the most crowded feed in the city. Priyanka needed to stand out as a trusted advisor people actually want to hear from — not another agent posting floor plans.',
    solution: 'We handle the page end to end: shooting on-location reels like this Rahman Island walkthrough, writing the hooks and captions, and keeping a consistent, confident voice across every post.',
    deliverables: ['Page management', 'On-location reels', 'Hooks & captions', 'Content calendar'],
    outcome: 'Live on @priyankabhatia.uae.',
  },
  {
    id: 'work-3',
    client: 'Bread n Batter Co',
    title: 'The Chocolate Hug',
    category: 'Food Photography & Social',
    filter: 'brand',
    year: '2025',
    image: '/assets/work/bread-n-batter/chocolate-hug-1.jpg',
    gallery: ['/assets/work/bread-n-batter/chocolate-hug-1.jpg', '/assets/work/bread-n-batter/chocolate-hug-2.jpg'],
    link: { label: 'See the post on Instagram', href: 'https://www.instagram.com/p/DD6oNNIyhPr/' },
    summary: 'Food photography and social content for an artisan bakery — styled, shot and captioned by Butter Media for @breadnbatterco.',
    challenge: 'Dessert sells on sight. Bread n Batter Co needed each new flavour drop to look as good on the feed as it tastes at the counter — and a voice warm enough to keep people coming back for the next one.',
    solution: 'We styled and shot “The Chocolate Hug” — torched marshmallow over dark chocolate on rustic wood, festive gold in the frame — and wrote the caption that turned a weekly flavour into a small event.',
    deliverables: ['Food styling', 'Product photography', 'Captions & concepts', 'Instagram content'],
    outcome: 'Live on @breadnbatterco.',
  },
  {
    id: 'work-4',
    client: 'Knot Home',
    title: 'Home, in Arabic',
    category: 'Arabic Website Copy',
    filter: 'digital',
    year: '2026',
    image: '/assets/work/knot-home/section-0.jpg',
    galleryFit: 'contain',
    gallery: ['/assets/work/knot-home/section-0.jpg', '/assets/work/knot-home/section-1.jpg', '/assets/work/knot-home/section-2.jpg', '/assets/work/knot-home/section-3.jpg', '/assets/work/knot-home/section-5.jpg'],
    link: { label: 'Read it live at knothome.com/ar', href: 'https://knothome.com/ar' },
    summary: 'The complete Arabic edition of knothome.com — every headline, category, product story and promise on the site, written by Butter Media.',
    challenge: 'Knot Home’s English site had a warm, confident voice. The Arabic version had to feel written, not translated — natural to Gulf shoppers, true to the brand, and clean enough to read across hundreds of pages and products.',
    solution: 'We wrote the full Arabic website end to end: homepage, navigation and categories, product and collection copy, service promises and the try-before-you-buy programme — transcreated for rhythm and culture, not word for word.',
    deliverables: ['Arabic website copy', 'Transcreation', 'Navigation & category naming', 'Product & collection copy'],
    outcome: 'Live at knothome.com/ar — the whole site, in our words.',
  },
  {
    id: 'work-5',
    client: 'Battmobile',
    title: 'Think Car. Think Us.',
    category: 'Radio Jingle',
    filter: 'social',
    year: '2026',
    image: '/assets/work/battmobile-logo.jpg',
    audio: { src: '/assets/audio/battmobile-jingle.mp3', label: 'Jingle · 28 sec', title: 'Battmobile — “Think Car. Think Us.”' },
    summary: 'A 28-second audio jingle for Battmobile, the UAE’s on-demand car care service — concept, script and production by Butter Media.',
    challenge: 'Car care is a grudge purchase. Battmobile needed to be the name that comes to mind first — before the breakdown — and a sound people would recognise in seconds.',
    solution: 'We built the jingle around one line — “Think Car. Think Us.” — writing the script, shaping the hook and producing the final mix so the brand lands in the ear as fast as it does on the road.',
    deliverables: ['Jingle concept', 'Scriptwriting', 'Voice & music direction', 'Final mix'],
    outcome: 'A hook you can hum — press play.',
  },
  {
    id: 'work-11',
    client: 'Rawthar Shah',
    title: 'Built for Car Culture',
    category: 'Personal Brand Film',
    filter: 'film',
    year: '2026',
    image: '/assets/work/rawthar-cars-poster.jpg',
    reel: { type: 'mp4', src: '/assets/video/rawthar-cars.mp4', poster: '/assets/work/rawthar-cars-poster.jpg' },
    link: { label: 'Follow @rawtharshah_official', href: 'https://www.instagram.com/rawtharshah_official/' },
    summary: 'Rawthar Shah is a car maniac. Episode Ten of his series had to tap straight into that culture — and tell his story while it did. This was the result.',
    challenge: 'Car content is everywhere, and most of it looks the same: slow pans, loud music, nothing to say. Rawthar needed something that spoke fluently to people who live and breathe cars — without losing the person behind the wheel.',
    solution: 'We built the episode around him, not just the metal: his obsession, his story, his way of talking about cars. Shot and cut with the pace and angles car culture respects, so it earns the attention of the people who know the difference.',
    deliverables: ['Episode concept', 'On-location shoot', 'Edit & grade', 'Instagram delivery'],
    outcome: 'Episode Ten — live on @rawtharshah_official.',
  },
];

export const FAQS = [
  {
    q: 'What does a 360° engagement look like?',
    a: 'Strategy, content, production, design and management under one roof. We start by understanding your brand and audience, build a tailored strategy, create the content, revise it with you, and deliver work ready to engage, inform and convert.',
  },
  {
    q: 'How fast can you deliver?',
    a: 'Agility is one of our core promises. Whether you need content on a tight deadline or ongoing support, we adapt to your timeline without compromising quality.',
  },
  {
    q: 'Do you work in Arabic as well?',
    a: 'Yes — we are fully bilingual. We create and transcreate content in English and Arabic, tailored to cultural nuance so your message lands with every audience.',
  },
  {
    q: 'Do you take on retainers?',
    a: 'Absolutely. Many of our client family work with us on ongoing content retainers — a monthly rhythm of shoots, design, copy and community management tailored to your goals.',
  },
];
